import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBookmark } from '../../../store/BookSlice';
import { Button } from '../../_atoms/Button';
import { Canvas } from '../../_atoms/Canvas';
import { Book } from '../../_molecules/Book';
import { ImageButton } from '../../_molecules/ImageButton';

export const BookWrap = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  
  const onBookMark = () => {
    if (state.book.bookmark.filter((bookmark) => bookmark.book === state.book.current_book && bookmark.content === state.book.current_content && bookmark.page === state.book.current_page).length > 0) {
      const newBookmark = state.book.bookmark.filter((bookmark) => bookmark.book !== state.book.current_book || bookmark.content !== state.book.current_content || bookmark.page !== state.book.current_page);
      dispatch(setBookmark(newBookmark))
    } else {
      const bookmark = {
        book : state.book.current_book,
        content : state.book.current_content,
        page : state.book.current_page
      };

      dispatch(setBookmark([...state.book.bookmark, bookmark]));
    }
  };

  return (
    <>
      <Book />

      <Canvas />

      <Button type="bookMark" onClick={onBookMark} className={state.book.bookmark.filter((bookmark) => bookmark.book === state.book.current_book && bookmark.content === state.book.current_content && bookmark.page === state.book.current_page).length > 0 && 'act'}/>
      <ImageButton
        type="home"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_home_150px.png"
        alt="HOME"
        onClick={() => window.location.hash="#/"}
      />
      <ImageButton
        type="back"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_pre_150px.png"
        alt="BACK"
        onClick={() => window.location.hash="#/menu/" + (state.book.current_book + 1)}
      />
    </>
  );
};